import appInitializer from './appInitializer';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);
const ɵ0 = adapterFactory, ɵ1 = appInitializer.load;
export class AppModule {
}
export { ɵ0, ɵ1 };
